function getPropByString(obj, propString) {
  // return _.get(obj, propString, "-");
  if (!propString) return obj;

  // eslint-disable-next-line one-var
  let prop,
    props = propString.split('.');

  let i = 0;
  let iLen;

  for (i = 0, iLen = props.length - 1; i < iLen; i++) {
    prop = props[i];

    let candidate = obj[prop];
    if (candidate !== undefined) {
      obj = candidate;
    } else {
      break;
    }
  }
  return obj[props[i]];
}

const accessRow = (data, accessor) => {
  if (typeof accessor === 'string') return getPropByString(data, accessor);
  if (typeof accessor === 'function') return accessor(data);
  return '';
};

const initTableData = (tableConfig, data, primaryKey) => {
  const dataObjects = [];

  const columns = tableConfig.map(({ accessor, ...col }) => {
    const fieldName = col.field;
    if (!col.headerName) col.headerName = col.Header;
    delete col.Header;

    dataObjects.push({ accessor, fieldName });

    return col;
  });

  const rows = data.map((rowData, idx) => {
    const row = {};
    row.idx = idx + 1;

    if (primaryKey) row.id = rowData[primaryKey];
    else row.id = rowData.id || idx;

    dataObjects.forEach(
      (config) => (row[config.fieldName] = accessRow(rowData, config.accessor))
    );

    return row;
  });

  return { rows, columns };
};

export default initTableData;
